<template>
    <div class="pb-3 max-mob:pb-1.5">
        <CustomTableControls
            :showMultipleActions="!!tcpaShieldStore.selected.length"
            :headerType="SETTINGS_HEADER_TABLE.tcpaShield"
            :controlsParams="sortFilterTableStore.controlParams(SETTINGS_HEADER_TABLE.tcpaShield)"
            :selectedSorting="currentTable.selectedSorting"
            :selectedFilters="currentTable.selectedFilters"
            :searchValue="tcpaShieldStore.search"
            :onPage="tcpaShieldStore.onPage"
            :showButton="editTcpaShieldPermission"
            :onPageConfig="{ max: 100, min: 10, height: 'h-10' }"
            :dropdownButtonConfig="{ height: 'h-10' }"
            showOnPage
            showFilter
            showSort
            showSearch
            showReload
            showSettings
            @onAdd="openCreateDialog"
            @onChangeOnPage="tcpaShieldStore.changeOnPage"
            @onSelectedSorting="onSelectedSorting"
            @onSelectedFilters="updateSelectedFilters"
            @clearSortFilter="resetSortFilter"
            @onSearch="tcpaShieldStore.onSearch"
            @onReload="tcpaShieldStore.goToLoadTcpaShield"
        >
            <template #multipleActions>
                <DeleteIcon
                    v-if="deleteTcpaShieldPermission"
                    class="text-gray-200 hover:text-purple transition-colors cursor-pointer"
                    v-tippy="getTippyTable('Delete')"
                    @click="openSelectDeleteDialog"
                />
            </template>

            <template #dialogs>
                <CreateTcpaShieldDialog v-model="showCreateDialog" />

                <ConfirmDialog
                    v-model="showConfirmDialog"
                    :loading="tcpaShieldStore.actionLoading"
                    title="Delete Selected TCPA Shields"
                    subTitle="Are you sure you want to delete the selected Shields?"
                    prop
                    :confirmButtons="['Cancel', 'Confirm']"
                    @submitForm="deleteTcpaShield"
                />
            </template>
        </CustomTableControls>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import CustomTableControls from '@/components/table/controls/CustomTableControls.vue'
import DeleteIcon from '@/components/icons/DeleteIcon.vue'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import CreateTcpaShieldDialog from '@/views/call-tracking/tcpa-shield/components/dialogs/CreateTcpaShieldDialog.vue'

import { getTippyTable } from '@/helpers/tippy-helper'

import { useTcpaShieldStore } from '@/store/call-tracking/suppressionList/tcpaShieldStore'
import { usePermissionsStore } from '@/store/permissionsStore'
import { useSortFilterTableStore } from '@/store/sortFilterTableStore'

import { SETTINGS_HEADER_TABLE } from '@/constants/headersTable/settingsHeaderTable'

const tcpaShieldStore = useTcpaShieldStore()
const permissionsStore = usePermissionsStore()
const sortFilterTableStore = useSortFilterTableStore()

const showCreateDialog = ref(false)
const showConfirmDialog = ref(false)

const editTcpaShieldPermission = computed(() => permissionsStore.permissions.tcpaShield.edit)
const deleteTcpaShieldPermission = computed(() => permissionsStore.permissions.tcpaShield.delete)

const currentTable = computed(() => sortFilterTableStore.getTable(SETTINGS_HEADER_TABLE.tcpaShield))

function openCreateDialog() {
    showCreateDialog.value = true
}

function openSelectDeleteDialog() {
    showConfirmDialog.value = true
}

async function deleteTcpaShield() {
    const success = await tcpaShieldStore.goToDeleteTcpaShield(tcpaShieldStore.selected.map((item) => item.slug))

    if (success) {
        showConfirmDialog.value = false
    }
}

function onSelectedSorting(item, type) {
    switch (type) {
    case 'deleteAll':
        sortFilterTableStore.removeAllSorting(SETTINGS_HEADER_TABLE.tcpaShield)
        sortFilterTableStore.sendFiltersSorting(SETTINGS_HEADER_TABLE.tcpaShield)
        tcpaShieldStore.changePage(1)
        break
    case 'delete':
        sortFilterTableStore.changeSelectedSortingAfterDelete(item, SETTINGS_HEADER_TABLE.tcpaShield)
        sortFilterTableStore.sendFiltersSorting(SETTINGS_HEADER_TABLE.tcpaShield)
        tcpaShieldStore.changePage(1)
        break
    case 'update':
        sortFilterTableStore.sendFiltersSorting(SETTINGS_HEADER_TABLE.tcpaShield)
        tcpaShieldStore.changePage(1)
        break
    default:
        sortFilterTableStore.changeSelectedSortingAfterAdd(item, SETTINGS_HEADER_TABLE.tcpaShield)
        sortFilterTableStore.sendFiltersSorting(SETTINGS_HEADER_TABLE.tcpaShield)
        tcpaShieldStore.changePage(1)
    }
}

function resetSortFilter() {
    sortFilterTableStore.resetSortFilter(SETTINGS_HEADER_TABLE.tcpaShield)
    tcpaShieldStore.changePage(1)
}

function updateSelectedFilters(payload) {
    sortFilterTableStore.updateSelectedFilters(payload, SETTINGS_HEADER_TABLE.tcpaShield)
    tcpaShieldStore.changePage(1)
}
</script>
